<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 角色管理 strat -->
      <el-tab-pane name="first" label="角色管理">
        <el-table :data="roleManagement" border stripe >
          <el-table-column prop="id" label="ID" width="80px"></el-table-column>
          <el-table-column prop="name" label="角色名称" width="200px"></el-table-column>
          <el-table-column label="是否可以查看本部门所有审批数据" width="200px">
            <template slot-scope="scope">
              <span v-if="scope.row.bumenshenpidata === 1" style="color: #05bb74;">{{ scope.row.bumenshenpidataname }}</span>
              <span v-if="scope.row.bumenshenpidata === 2" style="color: #e95d4e;">{{ scope.row.bumenshenpidataname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="角色描述" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickeditrole(scope.$index,scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickpermissions(scope.$index,scope.row)">权限设置</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="deleteRole(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 编辑角色弹出框 start -->
        <el-dialog title="编辑角色" :visible.sync="editRoleInfo" width="50%" :close-on-click-modal="false">
          <el-form :model="editRoleForm" ref="addAaminFormRef" label-width="250px">
            <input v-model="editRoleForm.roleid" type="hidden"></input>

            <el-form-item label="角色名称" class="addAdminForm">
                <el-input v-model="editRoleForm.name" placeholder="请输入角色名称"></el-input>
            </el-form-item>

            <el-form-item label="是否可以查看本部门所有审批数据" class="addAdminForm">
                <el-select v-model="editRoleForm.bumenshenpidata" placeholder="请选择" class="select2">
                  <el-option key="1" label="可以" value="1"></el-option>
                  <el-option key="2" label="不可以" value="2"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="角色描述" class="addAdminForm">
                <el-input type="textarea" v-model="editRoleForm.remark" placeholder="请输入角色描述"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="funeditrole">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑角色弹出框 end -->

        <!-- 权限设置弹出框 start -->
        <el-dialog :title="edittitle" :visible.sync="permissionSettings" width="30%" :close-on-click-modal="false">
          <el-tree
            :data="menudata"
            :default-checked-keys="defaultcheckedkeys"
            show-checkbox
            :default-expand-all="true"
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            :accordion="true">
          </el-tree>
          <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="clicksavepermissions">保存</el-button>
          </span>
        </el-dialog>
        <!-- 权限设置弹出框 end -->
      </el-tab-pane>
      <!-- 角色管理 end -->

      <!-- 添加角色 start -->
      <el-tab-pane name="second" label="添加角色">
        <el-form :model="addRoleForm" ref="addAaminFormRef" label-width="250px">
          <el-form-item label="角色名称" class="addAdminForm">
            <el-input v-model="addRoleForm.name" placeholder="请输入角色名称"></el-input>
          </el-form-item>

          <el-form-item label="是否可以查看本部门所有审批数据" class="addAdminForm">
              <el-select v-model="addRoleForm.bumenshenpidata" placeholder="请选择" class="select2">
                <el-option key="1" label="可以" value="1"></el-option>
                <el-option key="2" label="不可以" value="2"></el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="角色描述" class="addAdminForm">
            <el-input type="textarea" v-model="addRoleForm.remark" placeholder="请输入角色描述"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="funaddrole">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加角色 end -->
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyRole',
  data () {
    return {
      activeName: 'first',
      addRoleForm: {
        name: '',
        bumenshenpidata: '',
        remark: ''
      },
      editRoleForm: {
        roleid: 0,
        name: '',
        bumenshenpidata: '',
        remark: ''
      },
      radio: '1',
      roleManagement: [],
      defaultcheckedkeys: [],
      editRoleInfo: false,
      permissionSettings: false,
      menudata: [],
      editroleid: 0,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      edittitle:'权限设置'
    }
  },
  mounted () {
    this.apigetallrole()
  },
  methods: {
    // 删除角色确认
    deleteRole (index, row) {
      this.$confirm('是否删除此角色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideleteonerole(row.id)
      })
    },
    clickreturn () {
      this.activeName = 'first'
    },
    funaddrole () {
      if (!this.addRoleForm.name) {
        this.$alert('请输入角色名称', '提示')
        return
      }
      if (!this.addRoleForm.remark) {
        this.$alert('请输入角色描述', '提示')
        return
      }
      this.apiaddrole()
    },
    clickeditrole (index, row) {
      this.editRoleForm.roleid = row.id
      this.editRoleForm.name = row.name
      this.editRoleForm.bumenshenpidata = row.bumenshenpidata.toString()
      this.editRoleForm.remark = row.remark
      this.editRoleInfo = true
    },
    clickpermissions (index, row) {
      this.editroleid = row.id
      this.edittitle = row.name
      this.apigetrolepermissions(row.id)
    },
    clicksavepermissions () {
      this.apieditrolepermissions(this.editroleid, this.$refs.tree.getCheckedKeys().toString())
    },
    funeditrole () {
      if (!this.editRoleForm.name) {
        this.$alert('请输入角色名称', '提示')
        return
      }
      if (!this.editRoleForm.remark) {
        this.$alert('请输入角色描述', '提示')
        return
      }
      this.apieditonerole()
    },
    apiaddrole: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = 0
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: this.addRoleForm.name,
        bumenshenpidata: this.addRoleForm.bumenshenpidata,
        remark: this.addRoleForm.remark
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addrole, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetallrole()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetallrole: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallrole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.roleManagement = []
            response.data.List.filter((item1, i1) => {
              that.roleManagement.push({ id: item1.Id, name: item1.Name, remark: item1.Remark,bumenshenpidata: item1.Bumenshenpidata,bumenshenpidataname: item1.Bumenshenpidataname })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditonerole: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = 0
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        roleid: this.editRoleForm.roleid,
        name: this.editRoleForm.name,
        bumenshenpidata: this.editRoleForm.bumenshenpidata,
        remark: this.editRoleForm.remark
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editonerole, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editRoleInfo = false
            that.apigetallrole()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetrolepermissions: function (roleid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        roleid: roleid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getrolepermissions, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.menudata = []
            response.data.Listmenu.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  list3.push({ id: item3.Id, label: item3.Authname, children: '' })
                })
                if (list3.length == 0) list3 = ''
                list2.push({ id: item2.Id, label: item2.Authname, children: list3 })
              })
              if (list2.length == 0) list2 = ''
              that.menudata.push({ id: item1.Id, label: item1.Authname, children: list2 })
            })
            that.defaultcheckedkeys = []
            response.data.Listpermissions.filter((item, i) => {
              that.defaultcheckedkeys.push(item.Menuid)
            })
            that.permissionSettings = true
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditrolepermissions: function (roleid, permissions) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = 0
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        roleid: roleid,
        permissions: permissions
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editrolepermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.permissionSettings = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideleteonerole: function (roleid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        roleid: roleid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteonerole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.apigetallrole()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
</style>
